import {useCallback} from 'react'
import {Ouvrage, OuvrageCreateCommand, OuvrageUpdateCommand} from "../../../model/ouvrage";
import {OuvrageType} from "../../../../../referentiels/ouvrageType";
import {RealizationRef} from "../../../../realization";
import {useFormComposable, useFormFieldComposable} from "@komune-io/g2";
import {FormComposable} from "@tracabois/components";
import {useTranslation} from "react-i18next";

export interface OuvrageUpdateFormProps {
  onSubmit?: (item: OuvrageUpdateCommand) => Promise<boolean> | boolean
  onCancel?: () => void
  ouvrage: Ouvrage
  ouvrageTypes: OuvrageType[]
  realizationRefs: RealizationRef[]
}

export const OuvrageUpdateForm = (props: OuvrageUpdateFormProps) => {
  const {
    onSubmit,
    onCancel,
    ouvrage,
    ouvrageTypes,
    realizationRefs
  } = props
  const { t } = useTranslation()
  const onSubmitMemoized = useCallback(
    async (values: OuvrageUpdateCommand): Promise<boolean> => {
      return onSubmit ? onSubmit({
        ...values,
      }) : false
    },
    [onSubmit]
  )

  const validate = (values: OuvrageCreateCommand) => {
    const errors:  Record<string,any> = {};
    const trimmed = (values?.name ?? '').trim()
    if (!trimmed) {
      errors["name"] = "Vous devez renseigner le type de l'ouvrage";

    }
    return errors;
  };

  const form = useFormComposable<OuvrageUpdateCommand>({
    onSubmit: onSubmitMemoized,
    formikConfig: {
      validate: validate,
      initialValues: {
        id: ouvrage.id,
        name: ouvrage.name,
        description: ouvrage.description,
        realization: ouvrage.realization
      }
    },
    actions: {
      validate: {
        label: t("save"),
      },
      cancel: {
        onClick: onCancel,
      }
    }
  })

  const formFields = useFormFieldComposable({
    fields: [
      {
        key: 'name',
        name: 'name',
        type: 'autoComplete',
        label: "Type de l'ouvrage",
        params: {
          textFieldProps: {
            placeholder: t("select"),
          },
          options: ouvrageTypes.map((item) => ({
            key: item.name,
            label: item.name
          }))
        }
      },
      {
        key: 'realization.id',
        name: 'realization.id',
        type: 'autoComplete',
        label: "Réalisation",
        params: {
          textFieldProps: {
            placeholder: t("select"),
          },
          options: realizationRefs.map((item) => ({
            key: item.id,
            label: item.name
          }))
        }
      },
    ],
  },[ouvrageTypes])

  return (
    <FormComposable
      fields={formFields.fields}
      formState={form}
      actions={form.actions}
      actionsProps={{
        direction: 'row',
        justifyContent: 'flex-end',
      }}
    />
  )
}
